import PrivacyContainer from "../../../components/pages/other/Privacy";

const Privacy = () => {
  return <PrivacyContainer />;
};

export default Privacy;
